/**
 * @deprecated Use Icon name="share" — kept for product detail share button.
 */
import Icon from "@/components/icons/Icon.jsx";

export default function ShareIcon({ className = "" }) {
    return <Icon name="share" className={className} />;
}
